import {QuestionType} from 'one.models/lib/models/QuestionTypes';

const QuestionnaireEQ5D3LEN = {
    identifier: 'EQ5D3L_EN',
    item: [
        {
            questionIdentifier: 'mobility',
            question: 'Your mobility TODAY',
            questionType: QuestionType.String
        },
        {
            questionIdentifier: 'selfCare',
            question: 'Your self-care TODAY',
            questionType: QuestionType.String
        },
        {
            questionIdentifier: 'usualActivities',
            question: 'Your usual activities TODAY',
            questionType: QuestionType.String
        },
        {
            questionIdentifier: 'pain',
            question: 'Your pain / discomfort TODAY',
            questionType: QuestionType.String
        },
        {
            questionIdentifier: 'anxiety',
            question: 'Your anxiety / depression TODAY',
            questionType: QuestionType.String
        },
        {
            questionIdentifier: 'healthState',
            question: 'YOUR HEALTH TODAY',
            questionType: QuestionType.String
        }
    ]
};

export default QuestionnaireEQ5D3LEN;
